import { SelectedAttributeValueInput } from '@sdk/gqlTypes/generatedTypes';

export enum ShareState {
  initial = 'initial',
  save = 'save',
  saveSuccess = 'save-success',
  share = 'share',
  addToWishlist = 'add-to-wishlist',
  removeToWishlist = 'remove-to-wishlist',
}

export interface IProps {
  initialState: ShareState;
  productCategory: string;
  variantId: string;
  productId: string;
  productImage: string;
  productName: string;
  productUrl: string;
  selectedProductAttributes: SelectedAttributeValueInput[];
}
